import { Submission } from '../../types';
import { getApiBaseUrl } from '../../utils/api-base-url';

export const requestSigner = async (
  signerEmail: string,
  urlSlug: string,
  submissionId: string,
  responses?: Record<string, unknown>,
): Promise<Submission> => {
  const response = await fetch(`${getApiBaseUrl()}/submissions/${urlSlug}/${submissionId}/signature/request`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: signerEmail,
      responses,
    }),
    credentials: 'include',
  });

  const body = await response.json();

  if (!response.ok || !body.success) {
    const errorMessage = body?.message || 'Failed to delete signer invitation.';
    throw new Error(errorMessage);
  }

  return body.data;
};
